{
    "Timezone_Default": "Padrão",
    "Timezone_International_Date_Line_West": "(GMT-12:00) Linha Internacional de Data Oeste",
    "Timezone_Midway": "(GMT-11:00) Ilha Midway",
    "Timezone_Hawaii": "(GMT-10:00) Havaí",
    "Timezone_Alaska_DLS": "(GMT-09:00) Alasca [DLS]",
    "Timezone_Pacific_Time_US_Canada_DLS": "(GMT-08:00) Horário do Pacífico (EUA \/ Canadá) [DLS]",
    "Timezone_Tijuana_Baja_California_DLS": "(GMT-08:00) Tijuana, Baixa Califórnia [DLS]",
    "Timezone_Arizona": "(GMT-07:00) Arizona",
    "Timezone_Chihuahua_La_Paz_Mazatlan": "(GMT-07:00) Chihuahua, La Paz, Mazatlán",
    "Timezone_Mountain_Time_US_Canada_DLS": "(GMT-07:00) Horário das Montanhas (EUA \/ Canadá) [DLS]",
    "Timezone_Central_America": "(GMT-06:00) América Central",
    "Timezone_Central_Time_US_Canada_DLS": "(GMT-06:00) Horário Central (EUA \/ Canadá) [DLS]",
    "Timezone_Guadalajara_Mexico_City_Monterrey": "(GMT-06:00) Guadalajara, Cidade do México, Monterrey",
    "Timezone_Saskatchewan": "(GMT-06:00) Saskatchewan",
    "Timezone_Bogota_Lima_Quito_Rio_Branco": "(GMT-05:00) Bogotá, Lima, Quito, Rio Branco",
    "Timezone_Eastern_Time_US_Canada_DLS": "(GMT-05:00) Horário do Leste (EUA \/ Canadá) [DLS]",
    "Timezone_Indiana_East_DLS": "(GMT-05:00) Indiana (Leste) [DLS]",
    "Timezone_Caracas": "(GMT-04:00) Caracas",
    "Timezone_Atlantic_Time_Canada_DLS": "(GMT-04:00) Horário do Atlântico (Canadá) [DLS]",
    "Timezone_La_Paz": "(GMT-04:00) La Paz",
    "Timezone_Manaus": "(GMT-04:00) Manaus",
    "Timezone_Georgetown": "(GMT-04:00) Georgetown",
    "Timezone_Santiago_DLS": "(GMT-04:00) Santiago [DLS]",
    "Timezone_Newfoundland_DLS": "(GMT-03:30) Terra Nova [DLS]",
    "Timezone_Brasilia": "(GMT-03:00) Brasília",
    "Timezone_Buenos_Aires": "(GMT-03:00) Buenos Aires",
    "Timezone_Montevideo": "(GMT-03:00) Montevidéu",
    "Timezone_Greenland_Godthab_DLS": "(GMT-02:00) Groenlândia (Godthab, Nuuk) [DLS]",
    "Timezone_Mid_Atlantic": "(GMT-02:00) Atlântico Médio",
    "Timezone_Azores_DLS": "(GMT-01:00) Açores [DLS]",
    "Timezone_Cape_Verde_Islands": "(GMT-01:00) Ilhas de Cabo Verde",
    "Timezone_Dublin_Edinburgh_Lisbon_London_DLS": "(GMT+00:00) Dublin, Edimburgo, Lisboa, Londres [DLS]",
    "Timezone_Greenwich_Mean_Time": "(GMT+00:00) Horário do Meridiano de Greenwich",
    "Timezone_Monrovia_Reykjavik": "(GMT+00:00) Monróvia, Reykjavik",
    "Timezone_Amsterdam_Berlin_Rome_Bern_Vienna_DLS": "(GMT+01:00) Amsterdã, Berlim, Roma, Berna, Viena [DLS]",
    "Timezone_Belgrade_Bratislava_Budapest_Prague_DLS": "(GMT+01:00) Belgrado, Bratislava, Budapeste, Praga [DLS]",
    "Timezone_Brussels_Copenhagen_Madrid_Paris_DLS": "(GMT+01:00) Bruxelas, Copenhague, Madri, Paris [DLS]",
    "Timezone_Sarajevo_Skopje_Warsaw_Zagreb_DLS": "(GMT+01:00) Sarajevo, Skopje, Varsóvia, Zagreb [DLS]",
    "Timezone_Casablanca_DST": "(GMT+01:00) Casablanca [DLS]",
    "Timezone_West_Central_Africa": "(GMT+01:00) África Centro-Ocidental",
    "Timezone_Windhoek": "(GMT+02:00) Windhoek",
    "Timezone_Athens_Bucharest": "(GMT+02:00) Atenas; Bucareste",
    "Timezone_Beirut_DLS": "(GMT+02:00) Beirute [DLS]",
    "Timezone_Cairo_DLS": "(GMT+02:00) Cairo [DLS]",
    "Timezone_Harare_Pretoria": "(GMT+02:00) Harare, Pretória",
    "Timezone_Helsinki_Kyiv_Riga_Sofia_Tallinn_Vilnius_DLS": "(GMT+02:00) Helsínquia, Kiev, Riga, Sófia, Tallinn, Vilnius [DLS]",
    "Timezone_Jerusalem_DLS": "(GMT+02:00) Jerusalém [DLS]",
    "Timezone_Baghdad_DLS": "(GMT+03:00) Bagdá [DLS]",
    "Timezone_Amman": "(GMT+03:00) Amã; Istambul",
    "Timezone_Kuwait_Riyadh": "(GMT+03:00) Kuwait, Riad",
    "Timezone_Moscow_St_Petersburg_Volgograd": "(GMT+03:00) Moscou, São Petersburgo, Volgogrado",
    "Timezone_Minsk": "(GMT+03:00) Minsk",
    "Timezone_Nairobi": "(GMT+03:00) Nairóbi",
    "Timezone_Tehran": "(GMT+03:30) Teerã",
    "Timezone_Tbilisi": "(GMT+04:00) Tbilisi",
    "Timezone_Abu_Dhabi_Muscat": "(GMT+04:00) Abu Dhabi, Mascate",
    "Timezone_Baku": "(GMT+04:00) Baku",
    "Timezone_Mauritius": "(GMT+04:00) Maurício, Port Louis",
    "Timezone_Yerevan_DLS": "(GMT+04:00) Erevan [DLS]",
    "Timezone_Kabul": "(GMT+04:30) Cabul",
    "Timezone_Yekaterinburg": "(GMT+05:00) Ecaterimburgo",
    "Timezone_Islamabad_Karachi": "(GMT+05:00) Islamabad, Carachi",
    "Timezone_Tashkent": "(GMT+05:00) Tashkent, Astana, Almaty",
    "Timezone_Chennai_Kolkata_Mumbai_New_Delhi": "(GMT+05:30) Chennai, Calcutá, Mumbai, Nova Deli",
    "Timezone_Sri_Jayawardenepura": "(GMT+05:30) Colombo, Sri Jayawardenepura",
    "Timezone_Katmandu": "(GMT+05:45) Catmandu",
    "Timezone_Dhaka": "(GMT+06:00) Daca",
    "Timezone_Yangon_Rangoon": "(GMT+06:30) Yangon (Rangoon)",
    "Timezone_Bangkok_Jakarta": "(GMT+07:00) Bangkok, Jacarta",
    "Timezone_Krasnoyarsk": "(GMT+07:00) Krasnoyarsk",
    "Timezone_Novosibirsk": "(GMT+07:00) Novosibirsk",
    "Timezone_Hong_Kong": "(GMT+08:00) Pequim, Chongqing, Hong Kong, Urumqi",
    "Timezone_Irkutsk": "(GMT+08:00) Irkutsk, Ulaan Bataar",
    "Timezone_Kuala_Lumpur": "(GMT+08:00) Kuala Lumpur, Singapura",
    "Timezone_Perth": "(GMT+08:00) Perth",
    "Timezone_Taipei": "(GMT+08:00) Taipé",
    "Timezone_Tokyo": "(GMT+09:00) Osaka, Sapporo, Tóquio",
    "Timezone_Seoul": "(GMT+09:00) Seul",
    "Timezone_Yakutsk": "(GMT+09:00) Yakutsk",
    "Timezone_Adelaide": "(GMT+09:30) Adelaide [DLS]",
    "Timezone_Darwin": "(GMT+09:30) Darwin",
    "Timezone_Brisbane": "(GMT+10:00) Brisbane",
    "Timezone_Canberra_Melbourne_Sydney": "(GMT+10:00) Camberra, Melbourne, Sydney [DLS]",
    "Timezone_Port_Moresby": "(GMT+10:00) Guam, Porto Moresby",
    "Timezone_Hobart": "(GMT+10:00) Hobart [DLS]",
    "Timezone_Vladivostok": "(GMT+10:00) Vladivostok",
    "Timezone_Magadan": "(GMT+11:00) Magadan, Ilhas Salomão, Nova Caledônia",
    "Timezone_Auckland_Wellington": "(GMT+12:00) Auckland, Wellington [DLS]",
    "Timezone_Fiji": "(GMT+12:00) Fiji, Kamchatka, Ilhas Marshall",
    "Timezone_Tongatapu": "(GMT+13:00) Tongatapu",
    "Timezone_Samoa": "(GMT+13:00) Samoa",
    "Timezone_Kiritimati": "(GMT+14:00) Kiritimati, Ilha Christmas",
    "NAME": "Timezone"
}